// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"3c05d9ce","551":"b723f16e","828":"89fedf28","950":"2e78a1a9"}[chunkId] + ".chunk.js";
};